import { render } from "./BedItem.vue?vue&type=template&id=313aae7a&scoped=true"
import script from "./BedItem.vue?vue&type=script&lang=js"
export * from "./BedItem.vue?vue&type=script&lang=js"

import "./BedItem.vue?vue&type=style&index=0&id=313aae7a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313aae7a"]])

export default __exports__